module.exports = __webpack_public_path__ + "catalog/items/firesafety/warning/warning.svg";